import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import styles from './CreateClassroomForm.module.scss'

const PROVIDERS = [
  { value: 'jitsi', label: 'Jitsi' },
  { value: 'zoom', label: 'Zoom' },
  { value: 'teams', label: 'MS Teams' },
]

const CreateClassroomForm = ({ onCreate, creating, error }) => {
  const { t } = useTranslation('common')

  const [provider, setProvider] = useState('jitsi')
  const [scheduledAt, setScheduledAt] = useState('')
  const [externalUrl, setExternalUrl] = useState('')
  const [lessonId, setLessonId] = useState('')
  const [title, setTitle] = useState('')

  const submit = (e) => {
    e.preventDefault()
    if (!scheduledAt) return
    if ((provider === 'zoom' || provider === 'teams') && !externalUrl.trim()) return
    onCreate({
      provider,
      kind: provider,
      scheduled_at: new Date(scheduledAt).toISOString(),
      external_join_url: externalUrl.trim() || undefined,
      lesson_id: lessonId ? Number(lessonId) : undefined,
      title: title.trim() || undefined,
    })
  }

  const externalNeeded = provider === 'zoom' || provider === 'teams'

  return (
    <form className={styles.form} onSubmit={submit}>
      <div className={styles.formTitle}>{t('auto.createclassroomform_createclassroomform.k1')}</div>

      <div className={styles.field}>
        <label className={styles.label}>{t('distance.platform_label')}</label>
        <div className={styles.radioGroup}>
          {PROVIDERS.map((p) => (
            <label
              key={p.value}
              className={`${styles.radioOption} ${
                provider === p.value ? styles.radioActive : ''
              }`}
            >
              <input
                type="radio"
                name="provider"
                value={p.value}
                checked={provider === p.value}
                onChange={() => setProvider(p.value)}
              />
              {p.label}
            </label>
          ))}
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <label className={styles.label}>{t('distance.datetime_label')}</label>
          <input
            type="datetime-local"
            className={styles.input}
            value={scheduledAt}
            onChange={(e) => setScheduledAt(e.target.value)}
            required
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>{t('auto.createclassroomform_createclassroomform.k2')}</label>
          <input
            type="number"
            className={styles.input}
            value={lessonId}
            onChange={(e) => setLessonId(e.target.value)}
            placeholder="—"
          />
        </div>
      </div>

      <div className={styles.field}>
        <label className={styles.label}>{t('common.name')}</label>
        <input
          type="text"
          className={styles.input}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder={t('auto.createclassroomform_createclassroomform.k4')}
        />
      </div>

      {externalNeeded && (
        <div className={styles.field}>
          <label className={styles.label}>{t('auto.createclassroomform_createclassroomform.k3')}</label>
          <input
            type="url"
            className={styles.input}
            value={externalUrl}
            onChange={(e) => setExternalUrl(e.target.value)}
            placeholder="https://zoom.us/j/..."
            required
          />
        </div>
      )}

      {error && <div className={styles.error}>{error}</div>}

      <button type="submit" className={styles.submit} disabled={creating}>
        {creating ? 'Создание…' : 'Создать виртуальный класс'}
      </button>
    </form>
  )
}

export default CreateClassroomForm
